import {Tabs} from 'antd';
import {UserTab} from "../user/UserTab";
import {SystemCart} from "./SystemCart";

export const AdminTab = ({refresh, onRefresh, onApiFail, props}) => {
    const items = [
        {
            key: 'Users',
            label: 'Users',
            children: <UserTab refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'SystemCart',
            label: 'System Cart',
            children: <SystemCart refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
    ];

    const onTabChange = () => {
    }

    const onClick = () => {
    }

    return <Tabs defaultActiveKey={'Users'} tabPosition={'left'} items={items} onChange={onTabChange} onTabClick={onClick}/>
}